import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import moment from 'vue-moment'
import VueLocalStorage from 'vue-localstorage'
import api from './plugins/api'

Vue.use(moment)
Vue.moment.locale("ja", { weekdays: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"], weekdaysShort: ["日", "月", "火", "水", "木", "金", "土"], });

Vue.use(VueLocalStorage)
Vue.config.productionTip = false

Vue.mixin(api)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

